module.exports = __webpack_public_path__ + "img/utility_parked.3cb1e5de.svg";